import React from 'react';
import CompleteForm from '../CompleteForm';

/**
 * Export a component that render forgot-password page.
 */

const ForgotPasswordPage = () => (
	<CompleteForm
		name='Passwort vergessen'
		requestPath='/reset/reset-password'
		submitButton='Bestätigen'
		showEmail={true}
		showSubmitButton={true}
		goToButton={{
			name: 'Zurück zum Login',
			to: '/login',
		}}
	/>
);

export default ForgotPasswordPage;
